export default class TabsController {
  constructor() {
    this.DOM = {};
    this.DOM.tabs = Array.from(document.querySelectorAll('.plan__tab'));
    this.DOM.contents = Array.from(document.querySelectorAll('.plan__list'));
    this.state = {};
    this.state.current = 0;

    this.init();
  }

  init() {
    if (this.DOM.tabs.length === 0 || this.DOM.contents.length === 0) return;
    this.DOM.tabs[0].classList.add('plan__tab--active');
    this.DOM.contents[0].classList.add('plan__list--active');
    this.bindEvents();
  }

  bindEvents() {
    this.DOM.tabs.forEach(tab => tab.addEventListener('click', (event) => this.switch(event)));
  }

  switch(e) {
    e.preventDefault();
    this.state.current = this.DOM.tabs.indexOf(e.currentTarget);
    this.DOM.tabs.forEach(tab => tab.classList.remove('plan__tab--active'));
    this.DOM.contents.forEach(cont => cont.classList.remove('plan__list--active'));
    this.DOM.tabs[this.state.current].classList.add('plan__tab--active');
    this.DOM.contents[this.state.current].classList.add('plan__list--active');
  }
}
